import React from "react";
import "../Georeferenziazioni.scss";
import { AddIcon }  from "../../../assets/icons";
import CustomTooltip from "../../CustomTooltip";

  const GeoreferenziazioniHeader = ({
    edit = false,
    onOpenModal,
  }) => {
    return (
      <div className="georeferenziazioni-header">
          <p className="georeferenziazioni-header-title">Riferimenti GIS</p>
        {edit && (
          <CustomTooltip text="Aggiungi riferimento GIS">
            <button className="georeferenziazioni-button"  onClick={onOpenModal}>
                <AddIcon fillColor="var(--archeo-color)" />
            </button>
          </CustomTooltip>
        )}
      </div>
    );
  };

export default GeoreferenziazioniHeader;
